<template>
  <div class="login" :class="{ 'student': mode > 1 }">
    <div class="login-content">
      <img class="left" :src="baseImage" alt="">
      <div class="right">
        <el-card class="login-card">
          <h1 class="logo">{{ mode === 3 ? '忘记密码' : '百项过 登录' }}</h1>
          <el-form v-show="mode === 1" class="admin-form" :model="schoolForm">
            <el-form-item>
              <h3 class="hint">学校登录</h3>
              <el-input
                ref="schoolCode"
                v-model="schoolForm.schoolCode"
                @keyup.enter.native="autoFocus('schoolPassword')"
                placeholder="学校账号"
                maxlength="30">
              </el-input>
            </el-form-item>
            <el-form-item>
              <h3 class="hint">登录密码</h3>
              <el-input
                ref="schoolPassword"
                v-model="schoolForm.schoolPassword"
                @keyup.enter.native="preLogin"
                type="password"
                autocomplete="new-password"
                placeholder="学校密码"
                maxlength="30">
              </el-input>
            </el-form-item>
            <el-form-item class="text-ar">
              <el-button @click="preLogin" type="primary" class="btn-login btn-primary">
                下一步
              </el-button>
            </el-form-item>
          </el-form>
          <el-form v-show="mode === 2"  class="admin-form" :model="form" ref="form">
            <el-form-item prop="account">
              <h3 class="hint">学生账号</h3>
              <el-input
                v-model.trim="form.account"
                ref="account"
                @keyup.enter.native="autoFocus('password')"
                placeholder="账号"
                maxlength="11">
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <h3 class="hint">登录密码</h3>
              <el-input
                ref="password"
                v-model.trim="form.password"
                type="password"
                @keyup.enter.native="login"
                maxlength="30"
                autocomplete="new-password"
                placeholder="密码">
              </el-input>
            </el-form-item>
            <div class="back-school">
              <span @click="toggleForget">忘记密码</span>
              <span><i class="el-icon-question" /></span>
            </div>
            <el-form-item class="text-ar">
              <el-button
                class="normal btn-primary"
                type="primary"
                @click="backSchool">上一步</el-button>
              <el-button class="normal btn-primary" type="primary" @click="login">登录</el-button>
            </el-form-item>
          </el-form>
          <el-form v-show="mode === 3" class="forget-form" :model="forgetForm">
            <div class="toggle">
                <span @click="mode = 2">
                  <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/db628085b91a081ae58834fe60533642.png" alt="">
                  &nbsp;切换为学生</span>
            </div>
            <el-form-item>
              <el-input
                v-model="forgetForm.phone"
                ref="phone"
                @keyup.enter.native="autoFocus('code')"
                placeholder="学生手机号"
                maxlength="11">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="forgetForm.code"
                type="text"
                ref="code"
                @keyup.enter.native="autoFocus('newPassword')"
                autocomplete="new-password"
                placeholder="验证码"
                maxlength="6">
                <van-countdown
                  v-if="sended"
                  @timeout="sended = false"
                  :seconds="60"
                  slot="append" />
                <el-button v-else @click="sendCode" class="verify-btn" slot="append">
                  <span>获取验证码</span>
                </el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="forgetForm.password"
                ref="newPassword"
                @keyup.enter.native="autoFocus('repeat')"
                type="password"
                autocomplete="new-password"
                placeholder="请输入新密码"
                maxlength="30">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="forgetForm.repeatPassword"
                ref="repeat"
                type="password"
                @keyup.enter.native="forgetPassword"
                autocomplete="new-password"
                placeholder="请再输入一次新密码"
                maxlength="30">
              </el-input>
            </el-form-item>
            <el-form-item class="text-ar">
              <el-button @click="forgetPassword" type="primary" class="btn-login btn-primary">
                确定
              </el-button>
            </el-form-item>
          </el-form>
          <van-help />
        </el-card>
      </div>
    </div>
    <van-footer></van-footer>
  </div>
</template>

<script>
import VanFooter from '@/components/Footer.vue';
import utils from '@/services/utils';
import api from '@/api/graphql/account';
import VanCountdown from '@/components/common/Countdown.vue';
import VanHelp from '@/components/common/Help.vue';

import {
  Button,
  Card,
  Form,
  FormItem,
  Input,
} from 'element-ui';

export default {
  name: 'login',
  components: {
    ElCard: Card,
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElButton: Button,
    VanFooter,
    VanCountdown,
    VanHelp,
  },
  data() {
    return {
      mode: 1, // 1: 学校登录  2: 学生登录  3: 忘记密码
      isPass: false,
      schoolForm: {
        schoolCode: '',
        schoolPassword: '',
      },
      form: {
        account: '',
        password: '',
        schoolToken: '',
      },
      forgetForm: {
        phone: '',
        code: '',
        password: '',
        repeatPassword: '',
      },
      sended: false,
      isAllowLogin: true,
    };
  },
  watch: {
    form: {
      handler() {
        if (this.form.schoolToken) {
          this.mode = 2;
        }
      },
      deep: true,
    },
    mode: {
      handler() {
        this.$nextTick(() => {
          if (this.mode === 1) {
            this.$refs.schoolCode.focus();
          } else if (this.mode === 2) {
            this.$refs.account.focus();
          } else {
            this.$refs.phone.focus();
          }
        });
      },
      immediate: true,
    },
  },
  computed: {
    baseImage() {
      if (this.mode === 1) {
        return 'https://vanthink.oss-cn-qingdao.aliyuncs.com/6f306ee51f8e3268499a8967d34866ba.png';
      }
      return 'https://vanthink.oss-cn-qingdao.aliyuncs.com/d62eb86be40219952436f0f0a4ec39a8.png';
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const code = utils.params('code');
      const school = utils.storage('school');
      if (school) {
        this.mode = 2;
        this.form.schoolToken = utils.storage('school_token');
      } else if (code) {
        this.autoPreLogin(code);
      } else if (utils.storage('school_token')) {
        this.form.schoolToken = utils.storage('school_token');
      }
    },
    preLogin() {
      const verified = this.isPreLoginVerified();
      if (!verified || !this.isAllowLogin) {
        return;
      }

      this.isAllowLogin = false;

      api.preLogin(this.schoolForm)
        .then(({ preLogin }) => {
          this.isAllowLogin = true;
          this.form.schoolToken = preLogin.schoolToken;
          utils.storage('school_token', preLogin.schoolToken);
        })
        .catch(() => {
          this.isAllowLogin = true;
        });
    },
    autoFocus(name) {
      this.$refs[name].focus();
    },
    isPreLoginVerified() {
      if (this.isBlankText(this.schoolForm.schoolCode)) {
        utils.error('学校账号不能为空');
        return false;
      }

      if (this.isBlankText(this.schoolForm.schoolPassword)) {
        utils.error('学校密码不能为空');
        return false;
      }
      return true;
    },
    login() {
      const verified = this.isLoginVerified();
      if (!verified || !this.isAllowLogin) {
        return;
      }

      this.isAllowLogin = false;

      api.login(this.form)
        .then((res) => {
          this.isAllowLogin = true;
          utils.login(res.login);
          this.autoSkip();
        })
        .catch(() => {
          this.isAllowLogin = true;
        });
    },
    isLoginVerified() {
      if (this.isBlankText(this.form.account)) {
        utils.error('学生账号不能为空');
        return false;
      }

      if (this.isBlankText(this.form.password)) {
        utils.error('学生密码不能为空');
        return false;
      }
      return true;
    },
    backSchool() {
      utils.storage('school_token', null);
      this.mode = 1;
      this.schoolForm = {
        schoolCode: '',
        schoolPassword: '',
      };
      this.form = {
        account: '',
        password: '',
        schoolToken: '',
      };
      this.$nextTick(() => {
        this.$refs.schoolCode.focus();
      });
    },
    forgetPassword() {
      if (this.forgetForm.password !== this.forgetForm.repeatPassword) {
        utils.error('两次输入的密码不一致');
        return;
      }
      api.forgetPassword(this.forgetForm)
        .then(() => {
          this.forgetForm = {
            phone: '',
            code: '',
            password: '',
            repeatPassword: '',
          };
          this.mode = 2;
        });
    },
    sendCode() {
      const { phone } = this.forgetForm;
      if (!phone) {
        utils.error('请输入手机号');
        return;
      }
      if (!/^1[3456789][0-9]{9}$/.test(phone)) {
        utils.error('请输入正确的手机号');
        return;
      }
      this.sended = true;
      api.sendCaptcha({
        phone,
        type: 'student_password_reset',
      }).then(() => {
      }).catch(() => {
        this.sended = false;
      });
    },
    isBlankText(text) {
      return (!text || /^\s*$/.test(text));
    },
    autoPreLogin(code) {
      api.fetchSchoolToken({
        code,
      })
        .then(({ fetchSchoolToken }) => {
          this.form.schoolToken = fetchSchoolToken.schoolToken;
          utils.storage('school_token', fetchSchoolToken.schoolToken);
        });
    },
    autoSkip() {
      this.$router.replace('learning-center');
    },
    toggleForget() {
      this.mode = 3;
      if (this.form.account) {
        this.forgetForm.phone = this.form.account;
      }
    },
  },
};
</script>

<style lang="scss">
  @import '@/styles/variables.scss';
  .login {
    width: 100%;
    height: 100%;
    min-width: 1200px;
    min-height: 680px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-size: cover;
    background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/5213293a7d4fcfb8a713cdabb9b9336c.png');
    &.student {
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/3ea1aaf5c88d081a7e7db2d5debf99a2.jpg');
    }
    a {
      text-decoration: none;
      color: $grey-color;
    }
    .text-align-right {
      text-align: right;
    }
    .login-content {
      position: relative;
      width: 90%;
      display: flex;
      justify-content: space-between;
      border-radius: 20px;
      .left {
        width: 100%;
        min-width: 510px;
        overflow: hidden;
      }
      .left.student {
        background-image: url('https://img1.wxzxzj.com/vuede80cfe7551bb3648e241fa3ff300451b.png');
      }
      .right {
        position: absolute;
        right: 50px;
        top: 50%;
        width: 20%;
        height: 80%;
        min-width: 420px;
        min-height: 540px;
        max-height: 600px;
        text-align: center;
        transform: translateY(-50%);
        .el-card {
          border-radius: 0;
          border-radius: 20px;
        }
      }
    }
    .login-card {
      position: relative;
      height: 100%;
      color: #333;
      border: none;
      background: #5156e7;
      .logo {
        height: 32px;
        margin: 15px 0;
        color: #fff;
      }
      .el-card__body {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0;
        overflow: hidden;
        .el-form {
          flex: 1;
          box-sizing: border-box;
          box-sizing: border-box;
          margin: 0;
          padding: 0px 40px;
          text-align: left;
          border-radius: 20px;
          background: #fff;
          overflow: hidden;
          .el-form-item {
            margin-top: 20px;
            margin-bottom: 0;
            &.last {
              margin-top: 30px;
            }
            .el-button {
              width: 100%;
            }
            .normal {
              width: 40%;
            }
            .try {
              float: right;
              width: 35%;
            }
            button {
              height: 48px;
              border-radius: 10px;
              font-size: 18px;
            }
            .btn-login.el-button.el-button--primary {
              width: 150px;
            }
          }
          .el-form-item.text-ar {
            margin-top: 50px;
          }
          .back-school {
            padding-top: 38px;
            color: $primary;
            font-size: 18px;
            letter-spacing: 2px;
            color: #B0B0BD;
            overflow: hidden;
            span {
              font-size: 700;
              cursor: pointer;
            }
            span {
              float: right;
            }
          }
          @media screen and (max-height: 820px) {
            .el-form-item.text-ar {
              margin-top: 35px;
            }
            .back-school {
              padding-top: 24px;
            }
          }
        }
      }
      .van-help {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
      }
      .hint {
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 2px;
        margin-top: 0;
        margin-bottom: 20px;
      }
      .admin-form .el-input__inner {
        height: 48px;
        line-height: 48px;
        border-radius: 10px;
        border: 2px $border-color solid;
        background-color: #f6f5fb;
      }
      .forget-form {
        .toggle {
          margin-top: 20px;
          text-align: right;
          font-weight: 700;
          span {
            cursor: pointer;
          }
          img {
            vertical-align: middle;
          }
        }
        .el-input-group__append {
          padding: 0;
        }
        .verify-btn {
          margin: -10px 20px;
          width: auto!important;
          height: auto!important;
        }
        .el-input__inner {
          height: 44px;
        }
        .countdown {
          padding: 0 20px;
          &:hover {
            cursor: not-allowed;
          }
          height: 36px;
          .seconds {
            line-height: 36px;
            font-size: 28px;
          }
        }
      }
      .text-ar {
        .back {
          float: left;
          font-size: 18px;
          line-height: 48px;
          color: $primary;
          text-decoration: underline;
          cursor: pointer;
        }
        text-align: center;
      }
    }
    .btn-primary.el-button--primary {
      background-image: linear-gradient(to right, #5156e7, #7174de);
      border-radius: 25px!important;
      border: none;
      &:hover {
        background-image: linear-gradient(to bottom, #5156e7, #7174de);
        /*background-position: right top;*/
      }
    }
    .footer {
      font-size: 14px;
      color: #fff;
      bottom: 10px;
    }
  }

</style>
